import * as React from 'react'; // Tell cell that browser support sticky

var StickyContext = /*#__PURE__*/React.createContext(false);
export default StickyContext;